import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { ltUserKey } from "./environments/environment";
// import {useSelector} from 'react-redux';

/**
 * This component checks that user is eligible for visiting the private routes or not
 * check the condition for the for showing private route
 * if user is not eligible for visiting the private route then redirect it to the other route (login)
 */

const PrivateRoute = ({ component: Component, ...rest }) => {
  const {isAuthenticated} = useSelector(state => state.authData);
  let condition = JSON.parse(localStorage.getItem(ltUserKey)); // change the condition according to the requirement
  condition = condition && condition.api_token;
  return (
    <Route
      {...rest}
      render={props =>
        condition ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              from: { previousRoute: props.location } // by from we can redirect the user to the initial route after successful login
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;